import styled, { css } from "styled-components/macro";

const Wrapper = styled.section(({ theme }) => {
  return css`
    grid-area: welcome;
    width: min(${theme.rem(60)}, 100%);
  `;
});
export const StyledWelcome = { Wrapper };
